// extracted by mini-css-extract-plugin
module.exports = {"app__header":"bm_fp","app__footer":"bm_Z","app__flex_row":"bm_fq","app__content__list":"bm_fr"};